module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sl-d4cd148ff94760097b5c009e01b98e48.svg";